export let sanitizeString = (string) => {
  string = string.replace(
    /(?![ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyzáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙäëïöüÄËÏÖÜ0123456789\ \.\,\:\!\¡\?\¿\(\)])./g,
    ""
  );
  return string;
};

export let sanitizeName = (string) => {
  string = string.replace(
    /(?![ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyzáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙäëïöüÄËÏÖÜ0123456789\ ])./g,
    ""
  );
  return string;
};

export let sanitizeNIF = (string) => {
  string = string.replace(
    /(?![ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyz0123456789])./g,
    ""
  );
  return string;
};
